<template>
  <div class="section-main__warp analysis">
    <div class="analysis-item">
      <div class="item-region">
        <div class="item-region-row">
          <EnergyTrends></EnergyTrends>
          <EnergyTrendsMonth></EnergyTrendsMonth>
          <EnergyTrendsYear></EnergyTrendsYear>
        </div>
      </div>
    </div>
    <div class="analysis-item">
      <div class="item-region">
        <EnergyForecast></EnergyForecast>
      </div>
      <div class="item-region">
        <EnergyMonthTable></EnergyMonthTable>
      </div>
      <div class="item-region">
        <EnergyYearTable></EnergyYearTable>
      </div>
    </div>
  </div>
</template>

<script>
import EnergyTrends from '../components/EnergyTrends.vue';
import EnergyTrendsMonth from '../components/EnergyTrendsMonth.vue';
import EnergyTrendsYear from '../components/EnergyTrendsYear.vue';
import EnergyForecast from '../components/EnergyForecast.vue'
import EnergyMonthTable from '../components/EnergyMonthTable.vue';
import EnergyYearTable from '../components/EnergyYearTable.vue';
export default {
  components: {
    EnergyTrends,
    EnergyTrendsMonth,
    EnergyTrendsYear,
    EnergyForecast,
    EnergyMonthTable,
    EnergyYearTable
  }
}
</script>

<style lang="scss" scoped>
.analysis {
  display: flex;
  flex-direction: row;

  .analysis-item {
    flex: 1;
    display: flex;
    flex-direction: column;

    .item-region {
      flex: 1;
      display: flex;
      background-color: #ffffff;
      margin-bottom: 12px;

      .item-region-row {
        flex: 1;
        display: flex;
        flex-direction: column;
      }
    }
  }

  .analysis-item:not(:first-child) {
    margin-left: 10px;
  }
}
</style>